import { ComponentStyleConfig } from '@chakra-ui/react';

const themeSkeletonComponent: ComponentStyleConfig = {
  baseStyle: {
    borderRadius: 'md'
  }
};

export default themeSkeletonComponent;
